<template>
  <div class="tree-container">
    <a-tree
      class="tree"
      :block-node="true"
      :checkable="checkable"
      :show-icon="showIcon"
      :tree-data="treeData"
      :replaceFields="replaceFields"
      @select="onSelect"
      @check="onCheck"
      :selectedKeys.sync="selectedKeys"
      :expandedKeys.sync="expandedNodes"
      :checkedKeys="$store.getters['sessionAdd/treeDefaultCheckedVal']"
      :auto-expand-parent="autoExpandParent"
    >
      <svg-icon slot="corp" icon-class="corp"/>
      <svg-icon slot="org" icon-class="org"/>
      <template slot="avatar" slot-scope="props">
        <UserAvatar :user-avatar="props.avatar" />
      </template>
      <template slot="customTitle" slot-scope="item">
        <span class="name">{{ item.name }}</span>
        <DeviceType :deviceType="item.deviceType" :roomId="item.roomId" />
      </template>
    </a-tree>
  </div>
</template>

<script>
import { append, reject } from 'ramda'
import UserAvatar from '@/components/business/avatar/UserAvatar.vue'
import DeviceType from '@/components/business/DeviceType'
import { mapGetters } from 'vuex'

const getAllParentArr = (tree, id) => {
  for (const i in tree) {
    if (~String(tree[i].orgId).indexOf(id)) {
      return []
    }
    if (tree[i].orgList) {
      const node = getAllParentArr(tree[i].orgList, id)
      if (Array.isArray(node)) {
        return [tree[i].orgId].concat(node)
      }
    }
  }
}

export default {
  name: 'UserCompanyTree',
  props: {
    checkable: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    treeData: {
      type: Array,
      required: true,
      default: function () {
        return []
      }
    },
    replaceFields: {
      type: Object,
      default: function () {
        return {
          children: 'orgList',
          title: 'name',
          key: 'orgId'
        }
      }
    },
    autoExpandParent: {
      type: Boolean,
      default: false
    },
    treeExpandedList: {
      type: Array,
      default: function () {
        return []
      }
    },
    isLimitCheckedLength: {
      type: Boolean,
      default: true
    },
    limitLength: {
      type: Number,
      default () { return this.MAXROOMMEMBER }
    },
  },
  computed: {
    ...mapGetters(['MAXROOMMEMBER'])
  },
  data() {
    return {
      expandedNodes: this.treeExpandedList,
      selectedKeys: []
    }
  },
  components: { UserAvatar, DeviceType },
  inject: ['selectedKeysContext'],
  created(){
    this.selectedKeysContext.func = (uid) => this.clearSelectedKeys(uid)
  },
  methods: {
    clearSelectedKeys (uid) {
      this.selectedKeys = [`uid|${uid}`]
      this.expandedNodes = getAllParentArr(this.treeData, `uid|${uid}`)
    },
    onSelect(selectedKeys, { node }) {
      this.$emit('select', selectedKeys)
      const orgId = node.$props.dataRef.orgId
      // 部门的orgId为number，联系人的orgId为string，以 uid| 开头
      if (typeof orgId === 'number') {
        if (!node.$props.expanded) {
          this.expandedNodes = append(node.$props.dataRef.orgId, this.expandedNodes)
        } else {
          this.expandedNodes = reject(key => key === node.$props.dataRef.orgId, this.expandedNodes)
        }
      }
    },
    onCheck(checkedKeys) {
      if (
        this.isLimitCheckedLength &&
        (checkedKeys.filter(el => typeof el === 'string').length + this.$store.state.sessionAdd.notFriendsSelectedMembers.length > this.limitLength)
      ) {
        return this.$message.warn(`${this.$t('home.More32Members').replace('XX', this.limitLength)}`)
      }
      this.$emit('check', checkedKeys)
    }
  }
}
</script>

<style scoped lang="less">
.tree {
  font-weight: 500;
  color: #333;
  ::v-deep .corp-node > span > span.ant-tree-title {
    font-weight: bold;
  }
  .name{
    vertical-align: middle;
    display: inline-block;
    line-height: 20px;
  }
}
</style>
